let compIndex = 0;

export const getCompIndex = () => {
  return compIndex++;
};